
import { defineComponent, PropType, computed } from 'vue'

// Composables
import { useRouter } from '@/use/router'
import { UseDateRange } from '@/use/date-range'
import { usePercentiles } from '@/tracing/use-percentiles'
import { createQueryEditor } from '@/use/uql'

// Components
import EventRateChart from '@/components/EventRateChart.vue'
import SpanAttrs from '@/tracing/SpanAttrs.vue'
import NewMonitorMenu from '@/tracing/NewMonitorMenu.vue'

// Misc
import { SpanEvent } from '@/models/span'
import { AttrKey } from '@/models/otel'
import { Annotation } from '@/org/types'

export default defineComponent({
  name: 'EventPanelContent',
  components: { EventRateChart, SpanAttrs, NewMonitorMenu },

  props: {
    dateRange: {
      type: Object as PropType<UseDateRange>,
      required: true,
    },
    event: {
      type: Object as PropType<SpanEvent>,
      required: true,
    },
    annotations: {
      type: Array as PropType<Annotation[]>,
      default: () => [],
    },
  },

  setup(props) {
    const { route } = useRouter()

    const percentiles = usePercentiles(() => {
      if (!props.event.groupId) {
        return undefined
      }

      const { projectId } = route.value.params
      return {
        url: `/internal/v1/tracing/${projectId}/percentiles`,
        params: {
          ...props.dateRange.axiosParams(),
          system: props.event.system,
          group_id: props.event.groupId,
        },
      }
    })

    const spanListRoute = computed(() => {
      if (!props.event.groupId) {
        return undefined
      }
      return {
        name: 'SpanList',
        query: {
          ...props.dateRange.queryParams(),
          system: props.event.system,
          query: createQueryEditor()
            .exploreAttr(AttrKey.spanGroupId, true)
            .where(AttrKey.spanGroupId, '=', props.event.groupId)
            .toString(),
        },
      }
    })

    return {
      AttrKey,

      percentiles,
      spanListRoute,
    }
  },
})
